module.exports = __webpack_public_path__ + "static/media/LOGO_SOS_2.7e827407.png";